import {lazy} from 'react';

export const TestPageStepAsync = lazy(() =>
    import('./TestPageStep')
);
